import { useTranslation } from "react-i18next";
import i18n from "i18next";
const t = (key: string, fallback?: string) => i18n.t(key, fallback || key);
import { Modal } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { TableProps } from 'antd/lib';
import { useEffect, useState } from 'react';
import TableData from '../../../../../components/table-data/TableData';
import { historyUsingLearningMaterials } from '../../../../../service/course-construct';
import './HistoryModal.scss';
import dayjs from 'dayjs';

type HistoryRecord = {

  id: number,
  description: string,
  shareType: number,
  status: number,
  createdDate: string,
  createdBy: number
};

type Props = {
  open: boolean
  handleCancel: () => void
  handleOk: () => void
  historyId: number
}
const HistoryUseLearningModal = (props: Props) => {
  const { t } = useTranslation();
  const { open, handleCancel, handleOk, historyId } = props
  const [historyList, setHistoryList] = useState<HistoryRecord[]>([])
  const [totalUsed, setTotalUsed] = useState<number>(0)
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const columns: ColumnsType<HistoryRecord> = [
    {
      title: 'STT',
      dataIndex: 'numericalOrder',
      key: 'numericalOrder',
      width: '50px',
    },
    {
      title: t('Khoá học', 'Khoá học'),
      dataIndex: 'courseName',
      key: 'courseName',
    },
    {
      title: t('Học liệu', 'Học liệu'),
      dataIndex: 'unitName',
      key: 'unitName',
    },
    {
      title: t('Thời gian sử dụng', 'Thời gian sử dụng'),
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: (_: any, record, index: number) => {
        return <div>{record?.createdDate ? dayjs(record?.createdDate).format("HH:mm - DD/MM/YYYY") : ""}</div>;
      },
    },
    {
      title: t('Sử dụng bởi', 'Sử dụng bởi'),
      dataIndex: 'useBy',
      key: 'useBy',
    },
  ];

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await historyUsingLearningMaterials(historyId)
        setHistoryList(res?.data.data.content);
        setTotalUsed(res?.data.data.totalElements);

      } catch (error) {

      }
    }
    if (open) {
      fetchHistory()
    }
  }, [open, historyId])

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
  };

  return (
    <Modal
      title={t("Lịch sử sử dụng", "Lịch sử sử dụng")}
      centered
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      className='learning-material-history-modal'
    >
      <div>
        {t('Số lần sử dụng', 'Số lần sử dụng')}:&nbsp; <span className='font-weight-5 mt-2 mb-2'>{totalUsed || 0}</span>
      </div>
      <TableData
        dataColumns={columns}
        dataTable={historyList}
        hideSelection={false}
        handleTableChangeProps={handleTableChange}
        scroll={{ x: 0, y: 460 }}
        setPageNumber={setPageNumber}
        setPageSize={setPageSize}
        pageNumber={pageNumber}
        pageSize={pageSize}
        totalRecords={totalUsed}

        pagination
      />
    </Modal>
  );
};

export default HistoryUseLearningModal;
